"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AstGenVisitorv2 = void 0;
const custom_tree_1 = require("../custom_tree");
const base_1 = require("../custom_tree/base");
const math_nodes_1 = require("../custom_tree/math_nodes");
const parenthesis_expr_node_1 = require("../custom_tree/math_nodes/parenthesis.expr.node");
const antlr_files_1 = require("../antlr_files");
const foreign_node_1 = require("../custom_tree/foreign.node");
class AstGenVisitorv2 {
    ast;
    tabsContext;
    constructor(context) {
        this.tabsContext = context;
    }
    visitProgram(ctx) {
        return this.visitChildren(ctx);
    }
    visit(tree) {
        this.ast = new base_1.Tree();
        const r = this.visitProgram(tree);
        this.ast.createLinks();
        return r;
    }
    visitChildren(ctx) {
        if (!ctx.children?.length)
            return ctx;
        // Visit each child node in the order they appear
        for (let i = 0; i < ctx.children.length; i++) {
            const child = ctx.getChild(i);
            //@ts-ignore
            child.accept(this);
        }
        return ctx;
    }
    visitExprParenthesis(ctx) {
        const parenthesisExprAstNode = new parenthesis_expr_node_1.ParenthesisExprNode(ctx);
        this.ast.setToNodesToMap(ctx, parenthesisExprAstNode);
        // no root yet, parenthesis expr is the root
        if (!this.ast.root)
            this.ast.root = parenthesisExprAstNode;
        return this.visitChildren(ctx);
    }
    visitExprPow(ctx) {
        const powExprAstNode = new math_nodes_1.PowExprNode(ctx);
        this.ast.setToNodesToMap(ctx, powExprAstNode);
        // no root yet, pow expr is the root
        if (!this.ast.root)
            this.ast.root = powExprAstNode;
        return this.visitChildren(ctx);
    }
    visitExprTimesDiv(ctx) {
        const timesDivExprAstNode = new math_nodes_1.TimesDivExprNode(ctx);
        this.ast.setToNodesToMap(ctx, timesDivExprAstNode);
        // no root yet, times/div expr is the root
        if (!this.ast.root)
            this.ast.root = timesDivExprAstNode;
        return this.visitChildren(ctx);
    }
    visitExprPlusMinus(ctx) {
        const plusMinusExprAstNode = new math_nodes_1.PlusMinusExprNode(ctx);
        this.ast.setToNodesToMap(ctx, plusMinusExprAstNode);
        // no root yet, plus/minus expr is the root
        if (!this.ast.root)
            this.ast.root = plusMinusExprAstNode;
        return this.visitChildren(ctx);
    }
    visitExprComparison(ctx) {
        const comparisonExprAstNode = new custom_tree_1.ComparisonExprNode(ctx);
        this.ast.setToNodesToMap(ctx, comparisonExprAstNode);
        // no root yet, comparison expr is the root
        if (!this.ast.root)
            this.ast.root = comparisonExprAstNode;
        return this.visitChildren(ctx);
    }
    visitExprBoolean(ctx) {
        const booleanExprAstNode = new custom_tree_1.BooleanExprNode(ctx);
        this.ast.setToNodesToMap(ctx, booleanExprAstNode);
        // no root yet, boolean expr is the root
        if (!this.ast.root)
            this.ast.root = booleanExprAstNode;
        return this.visitChildren(ctx);
    }
    visitExprAtom(ctx) {
        const parent = ctx.parentCtx;
        if (!parent)
            return this.visitChildren(ctx);
        const singleChild = ctx.children?.[0];
        if (!singleChild)
            return this.visitChildren(ctx);
        if (!parent.children)
            return this.visitChildren(ctx);
        parent.children[parent.children.indexOf(ctx)] = singleChild;
        singleChild.parentCtx = parent;
        return this.visitChildren(ctx);
    }
    visitExprSignedAtom(ctx) {
        const signedAtomAstNode = new math_nodes_1.SignedExprNode(ctx);
        this.ast.setToNodesToMap(ctx, signedAtomAstNode);
        // no root yet, signed expr is the root
        if (!this.ast.root)
            this.ast.root = signedAtomAstNode;
        return this.visitChildren(ctx);
    }
    visitTerminal(ctx) {
        const createColumnNode = () => new custom_tree_1.ColumnNode(this.tabsContext, ctx);
        const createForeignNode = () => new foreign_node_1.ForeignNode(this.tabsContext, ctx);
        const createConcreteNode = () => new custom_tree_1.ConcreteNode(ctx);
        const createConstantNode = () => new custom_tree_1.ConstantNode(ctx);
        const createSymbolNode = () => new custom_tree_1.SymbolNode(ctx);
        // relevant nodes for our AST
        const terminalsAstCreatorMap = {
            [antlr_files_1.Lexer.COLUMN]: createColumnNode,
            [antlr_files_1.Lexer.ARGS_SPLITTER]: createConcreteNode,
            [antlr_files_1.Lexer.LPAREN]: createConcreteNode,
            [antlr_files_1.Lexer.RPAREN]: createConcreteNode,
            [antlr_files_1.Lexer.STRING]: createConstantNode,
            [antlr_files_1.Lexer.INT]: createConstantNode,
            [antlr_files_1.Lexer.FLOAT]: createConstantNode,
            [antlr_files_1.Lexer.BOOL]: createConstantNode,
            [antlr_files_1.Lexer.PERCENTAGE]: createConstantNode,
            [antlr_files_1.Lexer.MINUS]: createSymbolNode,
            [antlr_files_1.Lexer.PLUS]: createSymbolNode,
            [antlr_files_1.Lexer.DIV]: createSymbolNode,
            [antlr_files_1.Lexer.POW]: createSymbolNode,
            [antlr_files_1.Lexer.TIMES]: createSymbolNode,
            [antlr_files_1.Lexer.COMPARISON_OPERATIONS]: createSymbolNode,
            [antlr_files_1.Lexer.BOOLEAN_OPERATIONS]: createSymbolNode,
            [antlr_files_1.Lexer.RANGE_REFERENCE]: createForeignNode,
        };
        const astNodeCreator = terminalsAstCreatorMap[ctx.symbol.type];
        if (astNodeCreator) {
            const astNode = astNodeCreator();
            this.ast.setToNodesToMap(ctx, astNode);
            // no root yet, formula is the root
            if (!this.ast.root)
                this.ast.root = astNode;
        }
        return ctx;
    }
    visitErrorNode(ctx) {
        return ctx;
    }
    visitFormula(ctx) {
        const formulaAstNode = new custom_tree_1.FormulaNode(ctx);
        this.ast.setToNodesToMap(ctx, formulaAstNode);
        // no root yet, formula is the root
        if (!this.ast.root)
            this.ast.root = formulaAstNode;
        return this.visitChildren(ctx);
    }
    visitExpr(ctx) {
        return this.visitChildren(ctx);
    }
    visitAtom(ctx) {
        const parent = ctx.parentCtx;
        const singleChild = ctx.children?.[0];
        if (!singleChild)
            return this.visitChildren(ctx);
        if (!parent?.children)
            return this.visitChildren(ctx);
        parent.children[parent.children.indexOf(ctx)] = singleChild;
        singleChild.parentCtx = parent;
        return this.visitChildren(ctx);
    }
}
exports.AstGenVisitorv2 = AstGenVisitorv2;
